// extracted by mini-css-extract-plugin
module.exports = {"container-list":"ListOrders_container-list__2Y8Nt","container-scrollbar":"ListOrders_container-scrollbar__J2qST","wrapper-orders-cards":"ListOrders_wrapper-orders-cards__tJsCZ"};